import { Nullable } from '@orcar/common';
import styled from 'styled-components';
import {
  ContentWrapper,
  FlexColWrapper,
  InfoText,
  InfoTitle,
  SectionTitle,
} from './commonStyles';

interface PetReservationInfoProps {
  petCount: Nullable<number>;
  petTotalWeightKg: Nullable<number>;
  petBreed: Nullable<string>;
  isMobile: boolean;
}

/**
 * 반려동물 동반("펫과 함께") 예약 정보 (고객 예약 상세 노출).
 * 고객이 본인이 반려동물 동반으로 예약/결제했음을 확인할 수 있게 한다.
 * "종류"에는 입력한 반려동물 상세(품종/종류·무게)가 텍스트로 노출된다.
 */
const PetReservationInfo = ({
  petCount,
  petTotalWeightKg,
  petBreed,
  isMobile,
}: PetReservationInfoProps) => {
  return (
    <ContentWrapper>
      <SectionTitle isMobile={isMobile}>반려동물 동반 정보</SectionTitle>
      <FlexColWrapper gap='12px'>
        <InfoWrapper isMobile={isMobile}>
          <InfoTitle>종류</InfoTitle>
          <InfoText>{petBreed || '-'}</InfoText>
        </InfoWrapper>
        <InfoWrapper isMobile={isMobile}>
          <InfoTitle>마리 수</InfoTitle>
          <InfoText>{petCount != null ? `${petCount}마리` : '-'}</InfoText>
        </InfoWrapper>
        <InfoWrapper isMobile={isMobile}>
          <InfoTitle>총 무게</InfoTitle>
          <InfoText>
            {petTotalWeightKg != null ? `${petTotalWeightKg}kg` : '-'}
          </InfoText>
        </InfoWrapper>
      </FlexColWrapper>
    </ContentWrapper>
  );
};

export { PetReservationInfo };

const InfoWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => isMobile && 'column'};
  white-space: pre-line;
`;
